// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"0bb58e9d","600":"8c2ef931","638":"904f0f3f","768":"0b0fbabd","973":"77d29deb"}[chunkId] + ".css";
};